import script from "./CalorieProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./CalorieProgress.vue?vue&type=script&setup=true&lang=js"

import "./CalorieProgress.vue?vue&type=style&index=0&id=341d4c65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341d4c65"]])

export default __exports__